/**
 * UnitToggle.jsx
 *
 * DTH-only Metric / Imperial toggle. Thin wrapper around SP2 ToggleCard
 * primitive, wired to DSCContext.toggles.unitImperial. Default Metric
 * (unitImperial=false) matches legacy checkboxVal = false default.
 *
 * Citations (port-first):
 *  - Legacy LWC markup: My%20Rock%20Tools/force-app/main/default/lwc/
 *    searchResults/searchResults.html lines 200-219 - the
 *    <template if:false={isTopHammer}> block wrapping the
 *    slds-checkbox_toggle (DTH-only - TH does NOT have a unit toggle).
 *    Legacy label: <span class="checkbox-label">{checkboxLabel}</span>
 *    where checkboxLabel returns "Metric" when checkboxVal is falsy
 *    (searchResults.js:2615-2617) and "Imperial" when truthy.
 *  - Legacy handler: searchResults.js:2619-2698 handleUnitToggle() -
 *    intentionally does NOT call handleRestartConfigurator. State is
 *    duplicated in selectedDTH*Forcheckbox variables so selections survive
 *    the flip. The PWA equivalent is the DSCContext BOOTSTRAP effect
 *    (DSCContext.jsx:360-374) which re-runs on state.toggles.unitImperial
 *    change and re-derives the initialDropdownOptions map. Existing
 *    state.selections is preserved by the cascade reducer
 *    reduceToggleChange (dscCascade.js:633-684).
 *  - Plan section SP3.4: DTH UnitToggle must NOT call any restart.
 *  - Brainstorm DTH corrections line 154 + Q5: preserve compatible
 *    selections across flip.
 *
 * @module components/dsc/UnitToggle
 * @since 2026-05-20 (Group E SP3 - DTH-specific components)
 */

import { useDSCToggle } from '@contexts/DSCContext';
import ToggleCard from './ToggleCard';

export default function UnitToggle({ dataTestid = 'unit-toggle' } = {}) {
  const { value, setValue } = useDSCToggle('unitImperial');
  const label = value ? 'Imperial' : 'Metric';

  return (
    <ToggleCard
      id="dsc-unit-toggle"
      label={label}
      helperText="Switch the bit-diameter dropdown between millimetres and inches"
      value={value}
      onChange={setValue}
      dataTestid={dataTestid}
    />
  );
}
